export enum AppErrorCode {
  Session = 'session',
  Forbidden = 'forbidden',
  Unexpected = 'unexpected'
}
